"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MultiConditionalPermission = /** @class */ (function () {
    function MultiConditionalPermission() {
        // Public
        this.conditionalPermissions = [];
    }
    MultiConditionalPermission.prototype.addConditionalPermission = function (conditionalPermission) {
        this.conditionalPermissions.push(conditionalPermission);
    };
    MultiConditionalPermission.prototype.setChanged = function (value) {
        this.changed = this.changed || value;
    };
    MultiConditionalPermission.prototype.hasChanged = function () {
        return this.changed;
    };
    MultiConditionalPermission.prototype.toExpression = function (levels) {
        if (levels === void 0) { levels = 1; }
        var permissions = this.conditionalPermissions.filter(function (value) { return value.hasPermission(); });
        if (permissions.length) {
            if (levels === 2) {
                return this.optimizeTwoLevelExpression(permissions);
            }
            else {
                return "{\"$or\": [" + permissions.map(function (value) { return value.toExpression(); }).join(',') + "]}";
            }
        }
        return this.noPermission();
    };
    MultiConditionalPermission.prototype.optimizeTwoLevelExpression = function (conditionalPermissions) {
        var permissionsGroupedByCustom = new Map();
        var permissionByKeyMap = new Map();
        // group permissions by custom permission key
        for (var _i = 0, conditionalPermissions_1 = conditionalPermissions; _i < conditionalPermissions_1.length; _i++) {
            var cp = conditionalPermissions_1[_i];
            var conditionalPermission = cp;
            var key = conditionalPermission.permission.isFull ? 'FULL' : conditionalPermission.permission.permissionKey;
            if (!permissionsGroupedByCustom.has(key)) {
                permissionsGroupedByCustom.set(key, new Map());
                permissionByKeyMap.set(key, conditionalPermission.permission);
            }
            if (!permissionsGroupedByCustom.get(key).has(conditionalPermission.firstClassifierId)) {
                permissionsGroupedByCustom.get(key).set(conditionalPermission.firstClassifierId, []);
            }
            permissionsGroupedByCustom.get(key).get(conditionalPermission.firstClassifierId).push(conditionalPermission);
        }
        var expressionsForWfAction = [];
        permissionsGroupedByCustom.forEach(function (groupedByFirstClassifier, permissionKey) {
            var expressionsForCustomPermission = [];
            var customPermission = permissionByKeyMap.get(permissionKey);
            groupedByFirstClassifier.forEach(function (cp, fcId) {
                var secondClassifierIds = cp.map(function (value1) { return value1.secondClassifierId; });
                expressionsForCustomPermission.push("{\"$and\": [{\"" + cp[0].firstClassifierField + "\": " + fcId + "}, {\"" + cp[0].secondClassifierField + "\": {\"$in\": [" + secondClassifierIds.join(',') + "]}}]}");
            });
            if (customPermission.isFull) {
                expressionsForWfAction.push("{\"$or\": [" + expressionsForCustomPermission.join(',') + "]}");
            }
            else {
                expressionsForWfAction.push("{\"$and\": [" + customPermission.expression + ", {\"$or\": [" + expressionsForCustomPermission.join(',') + "]}]}");
            }
        });
        return "{\"$or\": [" + expressionsForWfAction.join(',') + "]}";
    };
    return MultiConditionalPermission;
}());
exports.MultiConditionalPermission = MultiConditionalPermission;
//# sourceMappingURL=multi-conditional-permission.js.map